































































import { computed, defineComponent, ref } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import ButtonList from '@front-app/components/dropdowns/ButtonList.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import { usePhoenixCookie } from '@front-app/hooks/usePhoenixCookie';
import { MenuOptions, useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { SETTINGS_ICON } from '@front-app/vendor/icon-definitions';
import { Routes } from '@front-app/constants/routes';

const LOCAL_ROUTES = [
	{
		key: MenuOptions.SECURITY_AND_ACCESS_CONTROL,
		id: MenuOptions.SECURITY_AND_ACCESS_CONTROL,
		label: 'admin-tabs.security-access-control',
		to: { name: Routes.GROUP_ADMIN_SECURITY_AND_ACCESS_CONTROL },
	},
	{
		key: MenuOptions.MEMBER_MANAGEMENT,
		id: MenuOptions.MEMBER_MANAGEMENT,
		label: 'admin-tabs.member-management',
		to: { name: Routes.GROUP_ADMIN_MEMBER_MANAGEMENT },
	},
	{
		key: MenuOptions.DESIGN_AND_CONFIGURATION,
		id: MenuOptions.DESIGN_AND_CONFIGURATION,
		label: 'admin-tabs.design-and-configuration',
		to: { name: Routes.GROUP_ADMIN_DESIGN_AND_CONFIGURATION },
	},
	{
		key: MenuOptions.NOTIFICATIONS_AND_DIGESTS,
		id: MenuOptions.NOTIFICATIONS_AND_DIGESTS,
		label: 'admin-tabs.notifications-and-digests',
		to: { name: Routes.GROUP_ADMIN_NOTIFICATIONS_AND_DIGESTS },
	},
	{
		key: MenuOptions.LEARNING_PROGRAM,
		id: MenuOptions.LEARNING_PROGRAM,
		label: 'admin-tabs.program-management',
		to: { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS },
	},
	{
		key: MenuOptions.LEARNING_PROGRAM_SURVEYS,
		id: MenuOptions.LEARNING_PROGRAM_SURVEYS,
		label: 'lms.admin.manage-surveys',
		to: { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS },
	},
	{
		key: MenuOptions.DATA_DASHBOARD,
		id: MenuOptions.DATA_DASHBOARD,
		label: 'admin-tabs.data-dashboard',
		to: { name: Routes.GROUP_ADMIN_DATA },
	},
];

export default defineComponent({
	components: {
		ButtonList,
		ChevronIcon,
		CtaButton,
		FontAwesomeIcon,
		PublicLink,
		SimpleDropdown,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));

		const isMenuOpen = ref(false);

		const {
			menuOptions,
			isFreeBeta,
		} = useAdminAccess(group);

		// Group Settings
		const { setRedirectSetting } = usePhoenixCookie();
		const groupSettingsUrl = computed(() => `/app/sgdp.shtml?hcgd=${group.value?.id}`);
		const visitGroupSettings = () => {
			setRedirectSetting(false);
		};
		const visitGroupSettingsInNewTab = () => {
			setRedirectSetting(false);
		};

		const isNavigationKeyAvailable = (key: MenuOptions) => menuOptions.value.includes(key);
		const localRoutes = computed(() => LOCAL_ROUTES.filter(({ key }) => isNavigationKeyAvailable(key)));

		return {
			isNavigationKeyAvailable,
			MenuOptions,
			localRoutes,
			group,
			isMenuOpen,
			menuOptions,
			isFreeBeta,
			SETTINGS_ICON,
			groupSettingsUrl,
			visitGroupSettings,
			visitGroupSettingsInNewTab,
		};
	},
});
